export default {
    popularProducts: 'No popular products found',
    favourites: 'No favourite products found',
    notifications: 'No notifications found',
    ordersByCity: 'No orders by city found',
    cart: 'No products found in the cart',
    collections: 'No collections found',
    invitations: 'No invitations found',
    inventories: 'No inventories found',
    reviews: 'No product reviews found',
    addresses: 'No addresses found',
    products: 'No products found',
    audit: 'No audit logs found',
    stores: 'No stores found',
    orders: 'No orders found',
    users: 'No users found',
    role: 'No role found',
    faq: 'No faqs found',
    chat: 'You have no messages at the moment',
    tokens: 'No api tokens',
    noMore: 'No more products. :('
}
